export const enum Brawlers {
	SHELLY = 'SHELLY',
	COLT = 'COLT',
	BULL = 'BULL',
	BROCK = 'BROCK',
	RICO = 'RICO',
	SPIKE = 'SPIKE',
	BARLEY = 'BARLEY',
	JESSIE = 'JESSIE',
	NITA = 'NITA',
	DYNAMIKE = 'DYNAMIKE',
	EL_PRIMO = 'EL PRIMO',
	MORTIS = 'MORTIS',
	CROW = 'CROW',
	POCO = 'POCO',
	BO = 'BO',
	PIPER = 'PIPER',
	PAM = 'PAM',
	TARA = 'TARA',
	DARRYL = 'DARRYL',
	PENNY = 'PENNY',
	FRANK = 'FRANK',
	GENE = 'GENE',
	TICK = 'TICK',
	LEON = 'LEON',
	ROSA = 'ROSA',
	CARL = 'CARL',
	BIBI = 'BIBI',
	BIT8 = '8-BIT',
	SANDY = 'SANDY',
	BEA = 'BEA',
	EMZ = 'EMZ',
	MR_P = 'MR. P',
	MAX = 'MAX',
	JACKY = 'JACKY',
	GALE = 'GALE',
	NANI = 'NANI',
	SPROUT = 'SPROUT',
	SURGE = 'SURGE',
	COLETTE = 'COLETTE',
	AMBER = 'AMBER',
	LOU = 'LOU',
	BYRON = 'BYRON',
	EDGAR = 'EDGAR',
	COLONEL_RUFFS = 'COLONEL RUFFS',
	STU = 'STU',
	BELLE = 'BELLE',
	SQUEAK = 'SQUEAK',
	GROM = 'GROM',
	BUZZ = 'BUZZ',
	GRIFF = 'GRIFF',
	ASH = 'ASH',
	MEG = 'MEG',
	LOLA = 'LOLA',
	FANG = 'FANG',
	EVE = 'EVE'
}

export const enum Events {
	GemGrab = 'GemGrab',
	SoloShowdown = 'SoloShowdown',
	BrawlBall = 'BrawlBall',
	HotZone = 'HotZone',
	DuoShowdown = 'DuoShowdown',
	Knockout = 'Knockout',
	BigGame = 'BigGame',
	Duels = 'Duels',
	Wipeout = 'Wipeout',
	Payload = 'Payload'
}
